"use strict";

var _toConsumableArray = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _slicedToArray = require("/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/slicedToArray.js");

require("core-js/modules/es.array.flat.js");

require("core-js/modules/es.array.unscopables.flat.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUniquePlugins = exports.getResolveConfig = exports.transformConfig = exports.getMergedConfig = exports.mergeExtends = exports.prefixRules = exports.transformApiDefinitionsToApis = exports.parsePresetName = void 0;

var utils_1 = require("../utils");

var config_1 = require("./config");

var logger_1 = require("../logger");

function parsePresetName(presetName) {
  if (presetName.indexOf('/') > -1) {
    var _presetName$split = presetName.split('/'),
        _presetName$split2 = _slicedToArray(_presetName$split, 2),
        pluginId = _presetName$split2[0],
        configName = _presetName$split2[1];

    return {
      pluginId: pluginId,
      configName: configName
    };
  } else {
    return {
      pluginId: '',
      configName: presetName
    };
  }
}

exports.parsePresetName = parsePresetName;

function transformApiDefinitionsToApis(apiDefinitions) {
  if (!apiDefinitions) return undefined;
  var apis = {};

  for (var _i = 0, _Object$entries = Object.entries(apiDefinitions); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        apiName = _Object$entries$_i[0],
        apiPath = _Object$entries$_i[1];

    apis[apiName] = {
      root: apiPath
    };
  }

  return apis;
}

exports.transformApiDefinitionsToApis = transformApiDefinitionsToApis;

function extractFlatConfig(_a) {
  var _b;

  var plugins = _a.plugins,
      _extends = _a.extends,
      rules = _a.rules,
      oas2Rules = _a.oas2Rules,
      oas3_0Rules = _a.oas3_0Rules,
      oas3_1Rules = _a.oas3_1Rules,
      preprocessors = _a.preprocessors,
      oas2Preprocessors = _a.oas2Preprocessors,
      oas3_0Preprocessors = _a.oas3_0Preprocessors,
      oas3_1Preprocessors = _a.oas3_1Preprocessors,
      decorators = _a.decorators,
      oas2Decorators = _a.oas2Decorators,
      oas3_0Decorators = _a.oas3_0Decorators,
      oas3_1Decorators = _a.oas3_1Decorators,
      rawConfigRest = __rest(_a, ["plugins", "extends", "rules", "oas2Rules", "oas3_0Rules", "oas3_1Rules", "preprocessors", "oas2Preprocessors", "oas3_0Preprocessors", "oas3_1Preprocessors", "decorators", "oas2Decorators", "oas3_0Decorators", "oas3_1Decorators"]);

  var styleguideConfig = {
    plugins: plugins,
    extends: _extends,
    rules: rules,
    oas2Rules: oas2Rules,
    oas3_0Rules: oas3_0Rules,
    oas3_1Rules: oas3_1Rules,
    preprocessors: preprocessors,
    oas2Preprocessors: oas2Preprocessors,
    oas3_0Preprocessors: oas3_0Preprocessors,
    oas3_1Preprocessors: oas3_1Preprocessors,
    decorators: decorators,
    oas2Decorators: oas2Decorators,
    oas3_0Decorators: oas3_0Decorators,
    oas3_1Decorators: oas3_1Decorators,
    doNotResolveExamples: (_b = rawConfigRest.resolve) === null || _b === void 0 ? void 0 : _b.doNotResolveExamples
  };

  if (rawConfigRest.lint && rawConfigRest.styleguide || Object.values(styleguideConfig).some(utils_1.isDefined) && (rawConfigRest.lint || rawConfigRest.styleguide)) {
    throw new Error("Do not use 'lint', 'styleguide' and flat syntax together. \nSee more about the configuration in the docs: https://redocly.com/docs/cli/configuration/ \n");
  }

  return {
    styleguideConfig: Object.values(styleguideConfig).some(utils_1.isDefined) ? styleguideConfig : undefined,
    rawConfigRest: rawConfigRest
  };
}

function transformApis(legacyApis) {
  if (!legacyApis) return undefined;
  var apis = {};

  for (var _i2 = 0, _Object$entries2 = Object.entries(legacyApis); _i2 < _Object$entries2.length; _i2++) {
    var _a = _Object$entries2[_i2];

    var _a2 = _slicedToArray(_a, 2),
        apiName = _a2[0],
        _b = _a2[1],
        lint = _b.lint,
        apiContent = __rest(_b, ["lint"]);

    var _extractFlatConfig = extractFlatConfig(apiContent),
        styleguideConfig = _extractFlatConfig.styleguideConfig,
        rawConfigRest = _extractFlatConfig.rawConfigRest;

    apis[apiName] = Object.assign({
      styleguide: styleguideConfig || lint
    }, rawConfigRest);
  }

  return apis;
}

function prefixRules(rules, prefix) {
  if (!prefix) return rules;
  var res = {};

  for (var _i3 = 0, _Object$keys = Object.keys(rules); _i3 < _Object$keys.length; _i3++) {
    var name = _Object$keys[_i3];
    res["".concat(prefix, "/").concat(name)] = rules[name];
  }

  return res;
}

exports.prefixRules = prefixRules;

function mergeExtends(rulesConfList) {
  var result = {
    rules: {},
    oas2Rules: {},
    oas3_0Rules: {},
    oas3_1Rules: {},
    preprocessors: {},
    oas2Preprocessors: {},
    oas3_0Preprocessors: {},
    oas3_1Preprocessors: {},
    decorators: {},
    oas2Decorators: {},
    oas3_0Decorators: {},
    oas3_1Decorators: {},
    plugins: [],
    pluginPaths: [],
    extendPaths: []
  };

  var _iterator = _createForOfIteratorHelper(rulesConfList),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _result$plugins, _result$pluginPaths, _result$extendPaths;

      var rulesConf = _step.value;

      if (rulesConf.extends) {
        throw new Error("'extends' is not supported in shared configs yet: ".concat(JSON.stringify(rulesConf, null, 2), "."));
      }

      Object.assign(result.rules, rulesConf.rules);
      Object.assign(result.oas2Rules, rulesConf.oas2Rules);
      utils_1.assignExisting(result.oas2Rules, rulesConf.rules || {});
      Object.assign(result.oas3_0Rules, rulesConf.oas3_0Rules);
      utils_1.assignExisting(result.oas3_0Rules, rulesConf.rules || {});
      Object.assign(result.oas3_1Rules, rulesConf.oas3_1Rules);
      utils_1.assignExisting(result.oas3_1Rules, rulesConf.rules || {});
      Object.assign(result.preprocessors, rulesConf.preprocessors);
      Object.assign(result.oas2Preprocessors, rulesConf.oas2Preprocessors);
      utils_1.assignExisting(result.oas2Preprocessors, rulesConf.preprocessors || {});
      Object.assign(result.oas3_0Preprocessors, rulesConf.oas3_0Preprocessors);
      utils_1.assignExisting(result.oas3_0Preprocessors, rulesConf.preprocessors || {});
      Object.assign(result.oas3_1Preprocessors, rulesConf.oas3_1Preprocessors);
      utils_1.assignExisting(result.oas3_1Preprocessors, rulesConf.preprocessors || {});
      Object.assign(result.decorators, rulesConf.decorators);
      Object.assign(result.oas2Decorators, rulesConf.oas2Decorators);
      utils_1.assignExisting(result.oas2Decorators, rulesConf.decorators || {});
      Object.assign(result.oas3_0Decorators, rulesConf.oas3_0Decorators);
      utils_1.assignExisting(result.oas3_0Decorators, rulesConf.decorators || {});
      Object.assign(result.oas3_1Decorators, rulesConf.oas3_1Decorators);
      utils_1.assignExisting(result.oas3_1Decorators, rulesConf.decorators || {});

      (_result$plugins = result.plugins).push.apply(_result$plugins, _toConsumableArray(rulesConf.plugins || []));

      (_result$pluginPaths = result.pluginPaths).push.apply(_result$pluginPaths, _toConsumableArray(rulesConf.pluginPaths || []));

      (_result$extendPaths = result.extendPaths).push.apply(_result$extendPaths, _toConsumableArray(new Set(rulesConf.extendPaths)));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}

exports.mergeExtends = mergeExtends;

function getMergedConfig(config, apiName) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;

  var extendPaths = [].concat(_toConsumableArray(Object.values(config.apis).map(function (api) {
    var _a;

    return (_a = api === null || api === void 0 ? void 0 : api.styleguide) === null || _a === void 0 ? void 0 : _a.extendPaths;
  })), [(_b = (_a = config.rawConfig) === null || _a === void 0 ? void 0 : _a.styleguide) === null || _b === void 0 ? void 0 : _b.extendPaths]).flat().filter(utils_1.isTruthy);
  var pluginPaths = [].concat(_toConsumableArray(Object.values(config.apis).map(function (api) {
    var _a;

    return (_a = api === null || api === void 0 ? void 0 : api.styleguide) === null || _a === void 0 ? void 0 : _a.pluginPaths;
  })), [(_d = (_c = config.rawConfig) === null || _c === void 0 ? void 0 : _c.styleguide) === null || _d === void 0 ? void 0 : _d.pluginPaths]).flat().filter(utils_1.isTruthy);
  return apiName ? new config_1.Config(Object.assign(Object.assign({}, config.rawConfig), {
    styleguide: Object.assign(Object.assign({}, config.apis[apiName] ? config.apis[apiName].styleguide : config.rawConfig.styleguide), {
      extendPaths: extendPaths,
      pluginPaths: pluginPaths
    }),
    'features.openapi': Object.assign(Object.assign({}, config['features.openapi']), (_e = config.apis[apiName]) === null || _e === void 0 ? void 0 : _e['features.openapi']),
    'features.mockServer': Object.assign(Object.assign({}, config['features.mockServer']), (_f = config.apis[apiName]) === null || _f === void 0 ? void 0 : _f['features.mockServer']),
    files: [].concat(_toConsumableArray(config.files), _toConsumableArray((_j = (_h = (_g = config.apis) === null || _g === void 0 ? void 0 : _g[apiName]) === null || _h === void 0 ? void 0 : _h.files) !== null && _j !== void 0 ? _j : []))
  }), config.configFile) : config;
}

exports.getMergedConfig = getMergedConfig;

function checkForDeprecatedFields(deprecatedField, updatedField, rawConfig) {
  var isDeprecatedFieldInApis = rawConfig.apis && Object.values(rawConfig.apis).some(function (api) {
    return api[deprecatedField];
  });

  if (rawConfig[deprecatedField] && updatedField === null) {
    utils_1.showWarningForDeprecatedField(deprecatedField);
  }

  if (rawConfig[deprecatedField] && updatedField && rawConfig[updatedField]) {
    utils_1.showErrorForDeprecatedField(deprecatedField, updatedField);
  }

  if (rawConfig[deprecatedField] || isDeprecatedFieldInApis) {
    utils_1.showWarningForDeprecatedField(deprecatedField, updatedField);
  }
}

function transformConfig(rawConfig) {
  var migratedFields = [['apiDefinitions', 'apis'], ['referenceDocs', 'features.openapi'], ['lint', undefined], ['styleguide', undefined]];

  for (var _i4 = 0, _migratedFields = migratedFields; _i4 < _migratedFields.length; _i4++) {
    var _migratedFields$_i = _slicedToArray(_migratedFields[_i4], 2),
        deprecatedField = _migratedFields$_i[0],
        updatedField = _migratedFields$_i[1];

    checkForDeprecatedFields(deprecatedField, updatedField, rawConfig);
  }

  var apis = rawConfig.apis,
      apiDefinitions = rawConfig.apiDefinitions,
      referenceDocs = rawConfig.referenceDocs,
      lint = rawConfig.lint,
      rest = __rest(rawConfig, ["apis", "apiDefinitions", "referenceDocs", "lint"]);

  var _extractFlatConfig2 = extractFlatConfig(rest),
      styleguideConfig = _extractFlatConfig2.styleguideConfig,
      rawConfigRest = _extractFlatConfig2.rawConfigRest;

  return Object.assign({
    'features.openapi': referenceDocs,
    apis: transformApis(apis) || transformApiDefinitionsToApis(apiDefinitions),
    styleguide: styleguideConfig || lint
  }, rawConfigRest);
}

exports.transformConfig = transformConfig;

function getResolveConfig(resolve) {
  var _a, _b;

  return {
    http: {
      headers: (_b = (_a = resolve === null || resolve === void 0 ? void 0 : resolve.http) === null || _a === void 0 ? void 0 : _a.headers) !== null && _b !== void 0 ? _b : [],
      customFetch: undefined
    }
  };
}

exports.getResolveConfig = getResolveConfig;

function getUniquePlugins(plugins) {
  var seen = new Set();
  var results = [];

  var _iterator2 = _createForOfIteratorHelper(plugins),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var p = _step2.value;

      if (!seen.has(p.id)) {
        results.push(p);
        seen.add(p.id);
      } else if (p.id) {
        logger_1.logger.warn("Duplicate plugin id \"".concat(logger_1.colorize.red(p.id), "\".\n"));
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return results;
}

exports.getUniquePlugins = getUniquePlugins;